import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { register } from "./authService"; // Import the register function
import { AuthContext } from "./AuthContext";
import { useContext } from "react";


const RegistrationPage = () => {
  let newErrors = {}; // ✅ THIS LINE MUST BE HERE
  const [accountType, setAccountType] = useState("personal");
   
  const [success, setSuccess] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  useEffect(() => {
    document.title = "Registration | Workgear365";
  }, []);
  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY; // set in .env
  const billingStreetRef = useRef(null);
  const shippingStreetRef = useRef(null);
  const navigate = useNavigate();
  const [loadingMap, setLoadingMap] = useState(false);
  const { setUser } = useContext(AuthContext); // 👈 use context
  const [form, setForm] = useState({
    account_type: "personal", // ✅ ADD THIS
    name: "",
    email: "",
    phone: "",
    lastname: "",
    business_email: "",
    company_name: "",
    password: "",
    password_confirmation: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    zip_code: "",
    country: "USA",
    tax_id: "",
    payment_terms: "",
    notes:"",
 
   
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  /*const [sameAsBilling, setSameAsBilling] = useState(false);*/
  const [errors, setErrors] = useState([]);
  
  const [successMessage, setSuccessMessage] = useState("");
  /* scroll to error */
  const scrollToFirstError = (errorsObj) => {
  const firstField = Object.keys(errorsObj)[0];

  // find input by name
  const el = document.querySelector(`[name="name"]`);

  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.focus();
  } else {
    // if not found, go to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
/* added for password*/
  const [passwordStrength, setPasswordStrength] = useState({
    percent: 0,
    label: "Strength: N/A",
    color: "#f2a45b"
  });
  const updatePasswordMeter = (value) => { //alert('dfdfd');
    let score = 0;
  
    if (value.length >= 8) score += 1;
    if (value.length >= 12) score += 1;
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) score += 1;
    if (/[0-9]/.test(value)) score += 1;
    if (/[^A-Za-z0-9]/.test(value)) score += 1;
  
    const maxScore = 5;
    const pct = Math.round((score / maxScore) * 100);
  
    let label = "Strength: N/A";
    let color = "#f2a45b";
  
    if (value.length) {
      if (score <= 1) {
        label = "Strength: Weak";
        color = "#f08a4b";
      } else if (score <= 3) {
        label = "Strength: Fair";
        color = "#f9a44c";
      } else if (score === 4) {
        label = "Strength: Good";
        color = "#2fc8d6";
      } else {
        label = "Strength: Strong";
        color = "#1f9d6d";
      }
    }
    setPasswordStrength({
      percent: pct,
      label,
      color
    });
  };
  const updatePasswordMatch = (password, password_confirmation) => {
    if (!password_confirmation) {
      if (password) {
        setPasswordMatch({
          status: "error",
          message: "❌ Confirm your password"
        });
      } else {
        setPasswordMatch({ status: null, message: "" });
      }
      return;
    }
  
    if (password === password_confirmation) {
      setPasswordMatch({
        status: "success",
        message: "✔ Passwords match"
      });
    } else {
      setPasswordMatch({
        status: "error",
        message: "❌ Passwords do not match"
      });
    }
  };
  const [passwordMatch, setPasswordMatch] = useState({
    status: null, // success | error | null
    message: ""
  });

  // Utility: load Google Maps script
  const loadGoogleMaps = () => {
    return new Promise((resolve, reject) => {
      if (window.google && window.google.maps && window.google.maps.places) {
        resolve(window.google);
        return;
      }
      if (!GOOGLE_API_KEY) {
        reject(new Error("Google API key is not set. Put REACT_APP_GOOGLE_API_KEY in your .env"));
        return;
      }

      // Avoid injecting multiple script tags
      if (document.querySelector(`script[data-google="places"]`)) {
        const check = setInterval(() => {
          if (window.google && window.google.maps && window.google.maps.places) {
            clearInterval(check);
            resolve(window.google);
          }
        }, 100);
        return;
      }

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.setAttribute("data-google", "places");
      script.onload = () => {
        resolve(window.google);
      };
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });
  };

  // Parse Google Place and return {address, city, state, zip}
  const parsePlaceToAddress = (place) => {
    const components = place.address_components || [];
    let streetNumber = "";
    let route = "";
    let city = "";
    let state = "";
    let postalCode = "";

    components.forEach((c) => {
      const types = c.types;
      if (types.includes("street_number")) streetNumber = c.long_name;
      if (types.includes("route")) route = c.long_name;
      if (types.includes("locality")) city = c.long_name;
      if (types.includes("administrative_area_level_1")) state = c.short_name || c.long_name;
      if (types.includes("postal_code")) postalCode = c.long_name;
      // fallbacks:
      if (!city && types.includes("sublocality") ) city = c.long_name;
      if (!city && types.includes("postal_town")) city = c.long_name;
    });

    const address = `${streetNumber} ${route}`.trim();
    return {
      address,
      city,
      state,
      zip_code: postalCode,
    };
  };

  // Initialize both autocomplete widgets
  useEffect(() => {
    let billingAutocomplete = null;
    let shippingAutocomplete = null;
    let mounted = true;

    setLoadingMap(true);
    loadGoogleMaps()
      .then((google) => {
        if (!mounted) return;

        // Billing autocomplete
        if (billingStreetRef.current) {
          billingAutocomplete = new google.maps.places.Autocomplete(billingStreetRef.current, {
            types: ["address"],
            componentRestrictions: { country: [] }, // empty => all countries; adjust to ['us'] if needed
          });
          billingAutocomplete.addListener("place_changed", () => {
            const place = billingAutocomplete.getPlace();
            const parsed = parsePlaceToAddress(place);
            setForm((prev) => {
              const next = {
                ...prev,
                address: parsed.address || prev.address,
                address2:parsed.address2 || prev.address2,
                city: parsed.city || prev.city,
                state: parsed.state || prev.state,
                zip_code: parsed.zip_code || prev.zip_code,
              };
              // if sameAsBilling is true, update shipping too
              /* if (sameAsBilling) {
                next.business_address = next.address;
                next.business_address2 = next.address2;
                next.business_city = next.city;
                next.business_state = next.state;
                next.business_zipcode = next.zip_code;
              } */
              return next;
            });
          });
        }

        // Shipping autocomplete
        if (shippingStreetRef.current) {
          shippingAutocomplete = new google.maps.places.Autocomplete(shippingStreetRef.current, {
            types: ["address"],
            componentRestrictions: { country: [] },
          });
          shippingAutocomplete.addListener("place_changed", () => {
            const place = shippingAutocomplete.getPlace();
            const parsed = parsePlaceToAddress(place);
          
            setForm((prev) => {
              const next = {
                ...prev,
                address: parsed.address || prev.address,
                address2: parsed.address2 || prev.address2,
                city: parsed.city || prev.city,
                state: parsed.state || prev.state,
                zip_code: parsed.zip_code || prev.zip_code,
              };
              return next;
            });
          });
        }
      }) 
      .catch((err) => {
        console.warn("Google Maps load failed:", err);
      })
      .finally(() => setLoadingMap(false));

    return () => {
      mounted = false;
      // no explicit cleanup for google listeners needed here
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  //re-init if sameAsBilling changed (to sync behavior)

  const handleAccountTypeChange = (e) => {
    const value = e.target.value;
  
    setAccountType(value); // UI
    setForm((prev) => ({
      ...prev,
      account_type: value, // ✅ sync with form
    }));
  };

 // Validation
 const validate = () => {
  let newErrors = {};

  if (accountType === "personal") { 
    if (!form.name) newErrors.name = "First name required";
    if (!form.lastname) newErrors.lastname = "Last name required";
  } else {
    if (!form.company_name) newErrors.company_name = "Company required";
  }

  if (!form.email) newErrors.email = "Email required";

  // ✅ PASSWORD VALIDATION FIXED
  if (!form.password) {
    newErrors.password = "Password required";
  } else if (form.password.length < 8) {
    newErrors.password = "Password too short";
  } else if (!/[0-9]/.test(form.password) && !/[^A-Za-z0-9]/.test(form.password)) {
    newErrors.password = "Add a number or symbol";
  }

  if (form.password !== form.password_confirmation) {
    newErrors.password_confirmation = "Passwords do not match";
  }
  if (!form.payment_terms) {
    newErrors.payment_terms = "Accept terms";
  }
  
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};
const handleChange = (e) => {
  const { name, value, files } = e.target;

  // File upload
  if (name === "tax_certificate") {
    const file = files[0];
    setForm((prev) => ({
      ...prev,
      tax_certificate: file
    }));
    setSelectedFileName(file ? file.name : "");
    return;
  }

  // ✅ THIS WAS MISSING (MAIN FIX)
  setForm((prev) => ({
    ...prev,
    [name]: value
  }));
};

  const handleSubmit = async (e) => {  
    //console.log("Form Data:", form);
    e.preventDefault();
    setErrors([]);
    setSuccessMessage("");
   
    // Basic client-side validation example (adjust as needed)
     if (!form.email || !form.password || !form.name) {
      setErrors(["Name, email and password are required."]);
      return;
    }
    if (form.password !== form.password_confirmation) {
      setErrors(["Password confirmation does not match."]);
      return;
    }

    
    try {
      const formData = new FormData();
      // ✅ ADD THIS DEBUG BLOCK HERE
     
      Object.keys(form).forEach((key) => {
        if (form[key] !== undefined && form[key] !== null) {
          formData.append(key, form[key]);
        }
      });
    
      const res = await register(formData);// Use the authService for registration
      
      setSuccessMessage(res.data.message || "Account created successfully.");
      setForm({
      company_name: "",
        name: "",
        email: "",
        phone: "",
        company_name: "",
        password: "",
        password_confirmation: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip_code: "",
        country: "USA",
        tax_id: "",
       
      }); 
     
       if (res.data && res.data.user) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("token", res.data.token);
        setUser(res.data.user); // 👈 update user in context
        navigate("/");
      }
    } 
    catch (err) {
         if (err.response && err.response.data && err.response.data.errors) {
          
          // Laravel validation payload
          const serverErrors = Object.values(err.response.data.errors).flat();
          
          setErrors(serverErrors);
          scrollToFirstError(serverErrors);
        } else if (err.response && err.response.data && err.response.data.message) {
          setErrors([err.response.data.message]);
           window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          setErrors(["Registration failed."]);
           window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
  };

  return (
    <div className="wg-shell">
    <div class="wg-card">
      <div class="wg-head">
        <div class="wg-title">Everything You Need for the Job &mdash; One Account</div>
        <div class="wg-sub">Create an account to save sizes, track orders, and access exclusive features.</div>
      </div>
      <div class="wg-benefits" aria-label="Account benefits">
        <h4>Why should I bother?</h4>
        <ul>
          <li><span>&#10003;</span> Faster checkout</li>
          <li><span>&#10003;</span> Track orders &amp; returns</li>
          <li><span>&#10003;</span> Save sizes and preferences</li>
          <li><span>&#10003;</span> Easy reordering for teams</li>
          <li><span>&#10003;</span> Access to trade pricing (for business accounts)</li>
        </ul>
      </div>
      <div class="wg-support-card">
        <div class="wg-support-title">Need help?</div>
        <div class="wg-support">
          <a href="tel:18005550199">1-855-385-2229</a>
          <span>or</span>
          <a href="mailto:support@workgear365.com">support@workgear365.com</a>
        </div>
      </div>

      <form onSubmit={handleSubmit} id="wgRegister">
        <div class="wg-section">
          <h3>Account Details</h3>
           {errors.length > 0 && (
                <div className="mb-3">
                  {errors.map((err, idx) => (
                    <div key={idx} className="alert alert-danger py-1">
                      {err}
                    </div>
                  ))}
                </div>
              )}

              {successMessage && (
                <div className="mb-3">
                  <div className="alert alert-success">{successMessage}</div>
                </div>
              )}
            <div className="wg-field">
              <label>Account type</label>
              <div class="wg-toggle-group" role="group" aria-label="Account type">
                <label class="wg-toggle-btn">
                <input
                  type="radio"
                  name="account_type"
                  value="personal"
                  checked={accountType === "personal"}
                  onChange={handleAccountTypeChange}
                />
                  <span class="wg-toggle-card">
                    <span class="wg-toggle-title">Personal account</span>
                    <span class="wg-toggle-sub">For individual orders</span>
                  </span>
                </label>
                <label class="wg-toggle-btn">
                <input
                  type="radio"
                  name="account_type"
                  value="business"
                  checked={accountType === "business"}
                  onChange={handleAccountTypeChange}
                />
                  <span class="wg-toggle-card">
                    <span class="wg-toggle-title">Business account</span>
                    <span class="wg-toggle-sub">For teams and trade pricing</span>
                  </span>
                </label>
              </div>
            </div>
            <div className={`wg-account-grid ${ accountType === "personal" ? "wg-account-grid-personal"
            : "wg-account-grid-business" } ${accountType !== "personal" ? "is-hidden" : ""}`}>
           <div className="wg-field">
              <label for="wgFirstName">First name *</label>
                    <input
                      type="text"
                      name="name"
                      id="wgFirstName"
                      className="wg-input"
                      value={form.name}
                      onChange={handleChange}
                      required={accountType === "personal"}
                    />
             
                  <div class="wg-field-status" id="wgFirstNameStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgLastName">Last name *</label>
             {/* <input type="text" id="wgLastName" class="wg-input" required autocomplete="family-name" /> */} 
              <input
                      type="text"
                      name="lastname"
                      id="wgLastName"
                      className="wg-input"
                      value={form.lastname}
                      onChange={handleChange}
                      required={accountType === "personal"}
                    />
              <div class="wg-field-status" id="wgLastNameStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgEmailPersonal">Email address *</label>
             {/* <input type="email" id="wgEmailPersonal" class="wg-input" required autocomplete="email" />*/}
              <input
                      type="email"
                      name="email"
                      id="wgEmailPersonal"
                      className="wg-input"
                      value={form.email}
                      onChange={handleChange}
                      required={accountType === "personal"}
                    />
              <div class="wg-field-status" id="wgEmailPersonalStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgPasswordPersonal">Password *</label>
              <div class="wg-input-row">
  {/*<input type="password" id="wgPasswordPersonal" class="wg-input" required autocomplete="new-password" />*/}
              
              <input type={showPassword ? 
              "text" : "password"}
              name="password"
              id="wgPasswordPersonal"
              className="wg-input"
              value={form.password}
              onChange={(e) => {
                const value = e.target.value;
              
                setForm((prev) => ({
                  ...prev,
                  password: value
                }));
              
                updatePasswordMeter(value); // ✅ strength update
                updatePasswordMatch(value, form.password_confirmation); // ✅ match check
              }}
              required={accountType === "personal"}
              autoComplete="new-password"
            />
            <button
              type="button"
              className="wg-toggle-pass"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
            </div>
              <div class="wg-helper">Use 8+ characters with a number or symbol.</div>
              <div class="wg-password-meter" aria-live="polite">
              <div className="wg-meter-label">
                {passwordStrength.label}
              </div>
              <div className="wg-meter-track">
                <div
                  className="wg-meter-fill"
                  style={{
                    width: `${passwordStrength.percent}%`,
                    background: passwordStrength.color
                  }}
                ></div>
              </div>
               {/*  <div class="wg-meter-track">
                  <div class="wg-meter-fill" id="wgPasswordMeterFillPersonal"></div>
                </div>
                <div class="wg-meter-label" id="wgPasswordMeterLabelPersonal">
                   Strength: N/A 
                  
                  </div> */}
              </div>
              <div class="wg-field-status" id="wgPasswordPersonalStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgPasswordConfirm">Confirm password *</label>
              <div class="wg-input-row">
                {/*<input type="password" id="wgPasswordConfirm" class="wg-input" required autocomplete="new-password" />
               */} 
              <input type={showConfirmPassword ? "text" : "password"}
              name="password_confirmation"
              id="wgPasswordConfirm"
              className="wg-input"
              value={form.password_confirmation}
              onChange={(e) => {
                const value = e.target.value;
              
                setForm((prev) => ({
                  ...prev,
                  password_confirmation: value
                }));
              
                updatePasswordMatch(form.password, value); // ✅ match check
              }}
              required={accountType === "personal"}
              autoComplete="new-password"
            />
            <button
              type="button"
              className="wg-toggle-pass"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
            {showConfirmPassword ? "Hide" : "Show"}
          </button>
          {passwordMatch.message && (
          <div className={passwordMatch.status === "success" ? "text-success" : "text-danger"}>
            {passwordMatch.message}
          </div>
        )}
          </div>
              <div class="wg-field-status" id="wgPasswordConfirmStatus">
                {errors.password_confirmation && (
                  <div className="text-danger">
                    {errors.password_confirmation}
                  </div>
                )}</div>
            </div>
             {/* personal Billing Address */}
             <div className="row mb-4">
                  <div className="col-12">
                    <h5 className="text-primary border-bottom pb-2 mb-3">
                      <i className="fa-solid fa-map-marker-alt me-2"></i>Billing Address
                    </h5>
                  </div>

                  <div className="wg-field">
                    <label className="form-label fw-bold">Street Address *</label>
                    <input
                      type="text"
                      id="businessBillingStreet"
                      name="address"
                      ref={billingStreetRef}
                      className="wg-input"
                      value={form.address}
                      onChange={handleChange}
                      placeholder="Street address"
                      required={accountType === "personal"}
                    />
                    
                  </div>

                  <div className="wg-field">
                    <label className="form-label fw-bold">Street Address Line 2</label>
                    <input
                      type="text"
                      name="address2"
                      placeholder="Suite Or Box #"
                      className="wg-input"
                      value={form.address2}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">City *</label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      className="wg-input"
                      value={form.city}
                      onChange={handleChange}
                      required={accountType === "personal"}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">State/Province *</label>
                    <select
                      name="state"
                      id="state"
                      className="wg-input"
                      value={form.state}
                      onChange={handleChange}
                      required={accountType === "personal"}
                    >
                      <option value="">Select State</option>
                      {/* Keep your state list here as needed; shorted for brevity */}
                      <option value="AL">Alabama</option>
                      <option value="CA">California</option>
                      <option value="NY">New York</option>
                      <option value="TX">Texas</option>
                      {/* add others */}
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">ZIP/Postal Code *</label>
                    <input
                      type="text"
                      name="zip_code"
                      id="zip_code"
                      className="wg-input"
                      value={form.zip_code}
                      onChange={handleChange}
                      required={accountType === "personal"}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Country *</label>
                    <select
                      name="country"
                      className="wg-input"
                      value={form.country}
                      onChange={handleChange}
                      required
                    >
                      <option value="USA">United States</option>
                      <option value="Canada">Canada</option>
                      <option value="Mexico">Mexico</option>
                    </select>
                  </div>
                  
                </div>
           </div>
          <div className={`wg-account-grid ${ accountType === "business" ? "wg-account-grid-business"
           : "wg-account-grid-personal" } ${accountType !== "business" ? "is-hidden" : ""}`}>
         
            <div className="wg-field">
              <label for="wgCompany">Company name *</label>
              {/*<input type="text" id="wgCompany" class="wg-input" required autocomplete="organization" />*/}
              <input
                      type="text"
                      name="company_name"
                      id="wgCompany"
                      className="wg-input"
                      value={form.company_name}
                      onChange={handleChange}
                      required={accountType === "business"}
                    />
              <div class="wg-field-status" id="wgCompanyStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgBusinessFirstName">Contact first name *</label>
              {/*<input type="text" id="wgBusinessFirstName" class="wg-input" required autocomplete="given-name" />*/}
              <input
                      type="text"
                      name="name"
                      id="wgBusinessFirstName"
                      className="wg-input"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
              <div class="wg-field-status" id="wgBusinessFirstNameStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgBusinessLastName">Contact last name *</label>
              {/*<input type="text" id="wgBusinessLastName" class="wg-input" required autocomplete="family-name" />*/}
              <input
                      type="text"
                      name="lastname"
                      id="wgBusinessLastName"
                      className="wg-input"
                      value={form.lastname}
                      onChange={handleChange}
                      required
                    />
              <div class="wg-field-status" id="wgBusinessLastNameStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgPasswordPersonal">Password *</label>
              <div class="wg-input-row">
  {/*<input type="password" id="wgPasswordPersonal" class="wg-input" required autocomplete="new-password" />*/}
              
              <input type={showPassword ? 
              "text" : "password"}
              name="password"
              id="wgPasswordPersonal"
              className="wg-input"
              value={form.password}
              onChange={(e) => {
                const value = e.target.value;
              
                setForm((prev) => ({
                  ...prev,
                  password: value
                }));
              
                updatePasswordMeter(value); // ✅ strength update
                updatePasswordMatch(value, form.password_confirmation); // ✅ match check
              }}
              required={accountType === "personal"}
              autoComplete="new-password"
            />
            <button
              type="button"
              className="wg-toggle-pass"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
            </div>
              <div class="wg-helper">Use 8+ characters with a number or symbol.</div>
              <div class="wg-password-meter" aria-live="polite">
              <div className="wg-meter-label">
                {passwordStrength.label}
              </div>
              <div className="wg-meter-track">
                <div
                  className="wg-meter-fill"
                  style={{
                    width: `${passwordStrength.percent}%`,
                    background: passwordStrength.color
                  }}
                ></div>
              </div>
               {/*  <div class="wg-meter-track">
                  <div class="wg-meter-fill" id="wgPasswordMeterFillPersonal"></div>
                </div>
                <div class="wg-meter-label" id="wgPasswordMeterLabelPersonal">
                   Strength: N/A 
                  
                  </div> */}
              </div>
              <div class="wg-field-status" id="wgPasswordPersonalStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgPasswordConfirm">Confirm password *</label>
              <div class="wg-input-row">
                {/*<input type="password" id="wgPasswordConfirm" class="wg-input" required autocomplete="new-password" />
               */} 
              <input type={showConfirmPassword ? "text" : "password"}
              name="password_confirmation"
              id="wgPasswordConfirm"
              className="wg-input"
              value={form.password_confirmation}
              onChange={(e) => {
                const value = e.target.value;
              
                setForm((prev) => ({
                  ...prev,
                  password_confirmation: value
                }));
              
                updatePasswordMatch(form.password, value); // ✅ match check
              }}
              required={accountType === "personal"}
              autoComplete="new-password"
            />
            <button
              type="button"
              className="wg-toggle-pass"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
            {showConfirmPassword ? "Hide" : "Show"}
          </button>
          {passwordMatch.message && (
          <div className={passwordMatch.status === "success" ? "text-success" : "text-danger"}>
            {passwordMatch.message}
          </div>
        )}
          </div>
              <div class="wg-field-status" id="wgPasswordConfirmStatus">
                {errors.password_confirmation && (
                  <div className="text-danger">
                    {errors.password_confirmation}
                  </div>
                )}</div>
            </div>
            <div className="wg-field">
              <label for="wgEmailBusiness" className="form-label">Email address *</label>
              <input 
              type="email" 
              name="email"
              id="wgEmailBusiness" 
              className="wg-input businessemail" 
              value={form.email}
              onChange={handleChange}
              required={accountType === "business"}
               />
              <div className="wg-field-status" id="wgEmailBusinessStatus"></div>
            </div>
            <div className="wg-field">
              <label for="wgWorkPhone" className="form-label">Phone number <span className="optional-text">(optional but suggested)</span></label>
              
              <div className="wg-input-row">
              {/*<input type="tel" id="wgWorkPhone" className="wg-input" inputmode="tel" autocomplete="tel" />*/}
              <input
                      type="tel"
                      name="phone"
                      id="wgWorkPhone"
                      className="wg-input"
                      value={form.phone}
                      onChange={handleChange}
                    />
                    
              <div className="wg-field-status" id="wgWorkPhoneStatus"></div>
            </div>
            </div>
            <div className="wg-field">
              <label className="form-label fw-bold">Tax ID</label>
              
                    <input
                      type="text"
                      name="tax_id"
                      className="wg-input"
                      value={form.tax_id}
                      onChange={handleChange}
                      placeholder="EIN, GST, etc."
                    />
                    <small className="text-muted ">
                        If Tax Exempt, please upload your Sales Tax Exemption Certificate here.
                        <span 
                          className="text-primary"
                          style={{ cursor: "pointer", textDecoration: "underline" }}
                          onClick={() => document.getElementById("tax_certificate_upload").click()}
                        >
                          upload
                        </span>
                      </small>

                      <input
                        type="file"
                        id="tax_certificate_upload"
                        name="tax_certificate"
                        className="d-none"
                        onChange={handleChange}
                      />
                     {selectedFileName && (
                        <span className="badge bg-success ms-2">
                          {selectedFileName}
                        </span>
                      )}
            </div>
            
             {/* business Billing Address */}
             <div className="row mb-4" style={{ gridColumn: "1 / -1" }}>
                 
                    <h5 className="text-primary border-bottom pb-2 mb-3">
                      <i className="fa-solid fa-map-marker-alt me-2"></i>Billing Address
                    </h5>
                 
                  <div className="wg-field">
                    <label className="form-label fw-bold">Street Address *</label>
                    <input
                      type="text"
                      id="street"
                      name="address"
                      ref={shippingStreetRef}
                      className="wg-input"
                      value={form.business_address}
                      onChange={handleChange}
                      placeholder="Street address"
                      required={accountType === "business"}
                    />
                    
                  </div>

                  <div className="wg-field">
                    <label className="form-label fw-bold">Street Address Line 2</label>
                    <input
                      type="text"
                      name="address2"
                      placeholder="Suite Or Box #"
                      className="wg-input"
                      value={form.business_address2}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="row">
                  <div className="col-md-4 mb-3 mt-3">
                    <div className="wg-field">
                      <label>City *</label>
                      <input
                        type="text"
                        name="city"
                        className="wg-input"
                        value={form.business_city}
                        onChange={handleChange}
                        required={accountType === "business"}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-3 mt-3">
                    <div className="wg-field">
                      <label>State/Province *</label>
                      <select
                        name="state"
                        className="wg-input"
                        value={form.business_state}
                        onChange={handleChange}
                        required={accountType === "business"}
                      >
                        <option value="">Select State</option>
                        <option value="AL">Alabama</option>
                        <option value="CA">California</option>
                        <option value="NY">New York</option>
                        <option value="TX">Texas</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3 mt-3">
                    <div className="wg-field">
                      <label>ZIP/Postal Code *</label>
                      <input
                        type="text"
                        name="zipcode"
                        className="wg-input"
                        value={form.business_zipcode}
                        onChange={handleChange}
                        required={accountType === "business"}
                      />
                    </div>
                  </div>
                </div>

                  <div className="wg-field">
                    <label className="form-label fw-bold">Country *</label>
                    <select
                      name="country"
                      className="wg-input"
                      value={form.business_country}
                      onChange={handleChange}
                      required
                    >
                      <option value="USA">United States</option>
                      <option value="Canada">Canada</option>
                      <option value="Mexico">Mexico</option>
                    </select>
                  </div>
            
                </div>
           </div>
        </div>

        <div class="wg-legal">
          <label class="wg-checkbox">
            <input type="checkbox" name="payment_terms" id="wgTerms" required />
            <span>I agree to the <a href="#" target="_blank" rel="noopener">Terms</a> &amp; <a href="#" target="_blank" rel="noopener">Privacy Policy</a> (required)</span>
          </label>
          <label class="wg-checkbox">
            <input type="checkbox" name="offer_update" id="wgMarketing" />
            <span>Send me offers &amp; updates (optional)</span>
          </label>
          <div class="wg-field-status" id="wgTermsStatus"></div>
        </div>

        <div class="wg-actions-register">
          <button type="submit" class="wg-btn-primary" form="wgRegister">Create account</button>
        </div>
      </form>

      <div class="wg-success" id="wgSuccess">
        <div class="wg-success-title">&#10003; Account created</div>
        <div class="wg-success-sub">Start shopping or complete your profile later.</div>
        <div class="wg-actions-register">
          <button type="button" class="wg-btn-primary" id="wgSuccessShop">Start shopping</button>
          <button type="button" class="wg-btn-secondary" id="wgSuccessProfile">Complete business details</button>
        </div>
      </div>

      <div class="wg-cta-sticky" id="wgStickyCta">
        <button type="submit" class="wg-btn-primary" form="wgRegister">Create account</button>
      </div>

      <div class="wg-footer1">Already have an account? <a class="wg-link" href="wg-login.html">Sign in</a>.</div>
    </div>
  </div>
  );
};

export default RegistrationPage;
